<template>
  <div
    class="btn main facebook"
    :class="{ disabled }"
    @click="$emit('click')"
    @mousedown="$emit('mousedown')"
    @mouseup="$emit('mouseup')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style scoped>
.main.btn.facebook:hover {
  color: var(--color-white);
  background-color: var(--color-dark-facebook);
}
.main.btn.facebook {
  background-color: var(--color-facebook);
  font-weight: 600;
}

.main.btn.facebook .btnText,
.main.btn.facebook >>> .btnText > span {
  vertical-align: middle;
  color: var(--color-white);
  font-weight: 600;
  font-family: EuclidFlex;
}
</style>

<style scoped src="./btn/shared.css"></style>
<style scoped src="./btn/shared_gt_768.css"></style>
<style scoped src="./btn/shared_gt_375.css"></style>
<style src="./btn/unscopedShared.css"></style>
<style src="./btn/unscopedShared375.css"></style>
